// extracted by mini-css-extract-plugin
export default {"heading":"typography_heading__bXbC3","subheading":"typography_subheading__m37U9","paragraph":"typography_paragraph__-TGk2"};